import React from 'react';
import './ContentSkeleton.css';

type Variant = 'guides' | 'faq' | 'tickets' | 'richtext';

interface ContentSkeletonProps {
  variant: Variant;
}

const Line: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`cskel cskel-line ${className || ''}`} />
);

/**
 * Skeletons de contenu personnalises par type d'onglet (Assistance, Mentions).
 * - guides  : cartes (titre + texte + media + bouton)
 * - faq     : accordeon (en-tete categorie + barres de questions)
 * - tickets : lignes de tickets
 * - richtext: blocs de texte (glossaire, pages legales)
 */
const ContentSkeleton: React.FC<ContentSkeletonProps> = ({ variant }) => {
  if (variant === 'guides') {
    return (
      <div className="cskel-guides" aria-hidden="true" aria-busy="true">
        {Array.from({ length: 3 }).map((_, i) => (
          <div className="cskel-guide-card" key={i}>
            <span className="cskel cskel-title" />
            <Line />
            <Line className="cskel-line--short" />
            <span className="cskel cskel-media" />
            <span className="cskel cskel-btn" />
          </div>
        ))}
      </div>
    );
  }

  if (variant === 'faq') {
    return (
      <div className="cskel-faq" aria-hidden="true" aria-busy="true">
        <span className="cskel cskel-faq-header" />
        {Array.from({ length: 6 }).map((_, i) => (
          <span className="cskel cskel-faq-q" key={i} />
        ))}
        <span className="cskel cskel-faq-header" />
        {Array.from({ length: 4 }).map((_, i) => (
          <span className="cskel cskel-faq-q" key={`b${i}`} />
        ))}
      </div>
    );
  }

  if (variant === 'tickets') {
    return (
      <div className="cskel-tickets" aria-hidden="true" aria-busy="true">
        {Array.from({ length: 5 }).map((_, i) => (
          <div className="cskel-ticket-row" key={i}>
            <span className="cskel cskel-ticket-status" />
            <span className="cskel cskel-ticket-main" />
            <span className="cskel cskel-ticket-date" />
          </div>
        ))}
      </div>
    );
  }

  // richtext (glossaire / pages legales)
  return (
    <div className="cskel-richtext" aria-hidden="true" aria-busy="true">
      {Array.from({ length: 3 }).map((_, s) => (
        <div className="cskel-rt-block" key={s}>
          <span className="cskel cskel-rt-h" />
          <Line />
          <Line />
          <Line className="cskel-line--short" />
          <Line />
        </div>
      ))}
    </div>
  );
};

export default ContentSkeleton;
